/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useCategories from "../../../utils/useCategories";
import useMultiSelect from "../../../utils/useMultiSelect.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import { toast } from "react-toastify";

// SVG Imports
import ICONS from "../../../assets/Icons";

// Redux Imports
import {
  addFieldForceTxnLabel,
  fieldForceTxnActionable,
  getAllfieldForceTxn,
  removeFieldForceTxnLabel,
  resetFFToggle,
  setToggleFFTxn,
} from "../../../redux/features/fieldForceTransaction";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources.js";
import { ownerAccountsViewAll } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount";

// Components Imports
import CommonToast from "../../../components/_utils/CommonToast";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import Loader from "../../../components/Loader/Index";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import ListContainer from "../../../components/_utils/CommonListView/ListContainer";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import SVGComponent from "../../../components/_utils/SVGComponent";
import TickerAnimation from "../../../components/_utils/TickerAnimation";
import ListDualText from "../../../components/_utils/CommonListView/ListSubComponent/ListDualText";
import ListTextWithIcon from "../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import useRestrictedAction from "../../../hooks/useRestrictedAction.js";
import SmallPopup from "../../../components/_utils/CommonSmallPopup/index.jsx";
import UseHandleScroll from "../../../hooks/useHandleScroll";

const FieldForceTransactionViewAll = (props) => {
  const isActionRestrictedMode = props?.isPopupMode;
  const isTxnHistoryPopup =
    props?.typepop === "txnHistorypopup" ||
    props?.typepop === "transactionHistorypopup";
  const isFieldForceHistoryPopup =
    props?.type === "field_force_txnViewAll_popup";
  const isRejectAssociatedTxnPopup =
    props?.flow === "reimburse_txnViewAll_popup_reject" ||
    props?.typepop === "reimburse_txnViewAll_popup_reject";
  const isEmbeddedPopup =
    isTxnHistoryPopup ||
    isFieldForceHistoryPopup ||
    props?.similarTxnType === "similarTxn";

  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const navStateAppliedRef = useRef(false);
  const lifecycleSyncedToUrlRef = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { startDateLocationState, endDateLocationState } = location.state || {};

  const categoryMapper = useCategories();
  // Pagination
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams(
    location?.state && location?.state?.approvalStatus
      ? {
          lifecycle: location.state.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        },
  );
  const [currentAccountId, SetcurrentAccountId] = useState("");
  const [closeCard, setCloseCard] = useState(false);
  // USESTATES
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [mainData, setMainData] = useState([]);

  // Label Popup
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [, setAnimateViewAll] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);

  // Filters
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || "",
  );

  // Top summary & label selection
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [labelTransactions, setLabelTransactions] = useState([]);

  // Owner account filter
  const [accountnumberstate, setaccountnumberstate] = useState("");
  const [accountNumber, setAccountNumber] = useState(
    props?.Owner_account_number ? props?.Owner_account_number : "",
  );
  const [ownerAccId, setOwnerAccId] = useState(
    props?.similarTxnType === "similarTxn" &&
      props?.queryParams?.owner_account_id
      ? props?.queryParams?.owner_account_id
      : searchParam.get("sourceAcc") || "",
  );

  // Category & label filters
  const [currentCategory, setCurrentCategory] = useState(
    props?.categoryName
      ? props?.categoryName
      : searchParam.get("category") || "",
  );
  const [labelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [labels, setLabels] = useState([]);

  // Amount & input helpers
  const [txnAmountFilter, setTxnAmountFilter] = useState(
    props?.similarTxnType === "similarTxn" && props?.queryParams?.amount
      ? props?.queryParams?.amount
      : searchParam.get("amount") || "",
  );
  const [inputData, setInputData] = useState([]);
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);
  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  // Date range filters
  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState
      ? startDateLocationState
      : convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState
      ? endDateLocationState
      : convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );

  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );

  const [isPaymentMethod, setIsPaymentMethod] = useState(
    props?.similarTxnType === "similarTxn" && props?.queryParams?.payment_method
      ? props?.queryParams?.payment_method
      : searchParam.get("paymentmethod") || "",
  );

  // Additional account-related filters
  const [currentIfscCode, setCurrentIfscCode] = useState("");
  const [accountNameValue, setAccountNameValue] = useState("");
  // PRIORITIZE EXPLICIT POPUP PROP OVER URL PARAMS
  const [selectedFfAccId, setSelectedFfAccId] = useState(
    props?.bene_account_id
      ? props?.bene_account_id
      : props?.similarTxnType === "similarTxn" &&
          props?.queryParams?.field_force_account_id
        ? props?.queryParams?.field_force_account_id
        : props?.TxnHistoryid
          ? props?.TxnHistoryid
          : searchParam.get("fFAcc") || "",
  );

  const [accountName, setAccountName] = useState(
    props?.bene_account_name || props?.TxnHistoryAccountName || "",
  );

  // Get the approval status passed from the dashboard or URL
  const initialApprovalStatus =
    location.state?.approvalStatus || searchParam.get("lifecycle") || "all";

  // Status filters (initialized from URL or location.state so filters persist on back)
  const [currentStatus, setCurrentStatus] = useState(
    initialApprovalStatus && initialApprovalStatus !== "all"
      ? initialApprovalStatus.toLowerCase()
      : props?.typepop === "reimburse_txnViewAll_popup_reject"
        ? "pending"
        : searchParam.get("lifecycle") || "",
  );
  const [currentDistributionStatus, setCurrentDistributionStatus] = useState(
    searchParam.get("distribution") || "",
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchdata, SetsearchData] = useState("");
  const [fFAccId, setFfAccId] = useState("");

  // SELECTORS
  const services = useSelector((state) => state.refreshToken.services);
  const { fieldForceTxnViewAllData, toggleFFTxn } = useSelector(
    (state) => state.fieldForceTransaction,
  );
  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  //FUNCTIONS
  const handleAction = async () => {
    setAnimateViewAll(false);
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          fieldForceTxnActionable({
            page_no: currentPage,
            page_size: pageSize,
            category: currentCategory,
          }),
        );

        const newApprovalData = responseApproval?.payload?.transactions || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setTotalBalanceAmount(
          responseApproval?.payload?.total_amount ||
            GlobalConfiguration?.lengthCheckZero,
        );
        setLoading(false);
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);

        let queryParams = {
          page_no: currentPage,
          page_item_count: pageSize,
        };

        if (currentDistributionStatus && currentDistributionStatus !== "all") {
          if (currentDistributionStatus === "complete") {
            queryParams.distribution_lifecycle_status = "distribution_complete";
          } else if (currentDistributionStatus === "initiated") {
            queryParams.distribution_lifecycle_status =
              "distribution_initiated";
          } else if (currentDistributionStatus === "pending") {
            queryParams.distribution_lifecycle_status = "distribution_pending";
          } else {
            queryParams.distribution_lifecycle_status =
              currentDistributionStatus;
          }
        }

        if (currentStatus) {
          queryParams.lifecycle_status = currentStatus;
        }

        if (currentDistributionStatus) {
          queryParams.distribution_lifecycle_status = currentDistributionStatus;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (isPaymentMethod) {
          queryParams.payment_method = isPaymentMethod;
        }

        if (ownerAccId && ownerAccId !== "") {
          queryParams.owner_account_id = ownerAccId;
        }

        if (selectedFfAccId) {
          queryParams.field_force_account_id = selectedFfAccId;
        }

        if (currentIfscCode) {
          queryParams.owner_account_ifsc_code = currentIfscCode;
        }

        // if (currentCategory) {
        //   queryParams.category = currentCategory;
        // }

        if (currentCategory !== "") {
          queryParams.category_id = currentCategory;
        }

        if (txnAmountFilter) {
          queryParams.amount = txnAmountFilter;
        }

        if (labelSearchText) {
          queryParams.labels = labelSearchText;
        }
        if (searchUserText !== "" && props?.seachType !== "rejectall") {
          queryParams.additional_data = searchUserText;
        }

        const response = await dispatch(getAllfieldForceTxn(queryParams));
        setMainData(response?.payload);
        const newData = response?.payload?.transactions || [];
        setAccumulatedData(newData);
        setLabels((prev) => {
          const fromApi = response?.payload?.summary?.available_labels || [];
          return Array.from(new Set([...(prev || []), ...fromApi]));
        });
        setLoading(false);
        setTotalBalanceAmount(
          response?.payload?.total_amount ||
            GlobalConfiguration?.lengthCheckZero,
        );
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
        setTotalBalanceAmount(GlobalConfiguration?.lengthCheckZero);
      }
    }
  };

  const onMount = () => {
    dispatch(resetFFToggle());
    // setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    // handleAction();
  };

  // Sync filter state to URL so filters persist when navigating away and back (same as BeneTxnViewall)
  const handleSubmit = (key, value) => {
    if (
      props?.typepop !== "transactionHistorypopup" &&
      props?.typepop !== "RejectAllTransactionPopup" &&
      props?.typepop !== "BeneAccRejectTxn" &&
      props?.typepop !== "txnHistorypopup" &&
      props?.similarTxnType !== "similarTxn"
    ) {
      handleSearchParams(key, value);
    }
  };

  // Pagination

  const handlePagination = (page) => {
    setDirection("");
    if (props?.similarTxnType !== "similarTxn") handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const selectableTransactions = accumulatedData
    ?.filter((item) => item?.approval_status !== "archived")
    ?.map((item) => ({ ...item, id: item?.txn_id }));

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      labelTransactions?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(
        labelTransactions,
        setLabelTransactions,
        value,
        selectableTransactions,
      );
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setAccumulatedData([]);
  };

  // Toggle

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }
    if (toggleFFTxn !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
      dispatch(setToggleFFTxn(newToggleValue));
    }
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration?.intervalMedium,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (!date || !date[0] || !date[1]) {
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }

    const [start, end] = date;

    setStartDateFilter(convertDate(start));
    setEndDateFilter(convertDate(end));
  };

  // Label Popup

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);

      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids?.[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      addFieldForceTxnLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (addFieldForceTxnLabel.fulfilled.match(res)) {
      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...(labelsToAssign || [])])),
      );
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;

      if (addFieldForceTxnLabel.rejected.match(res)) {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }
    setLoading(false);
    if (addFieldForceTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      removeFieldForceTxnLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeFieldForceTxnLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeFieldForceTxnLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeFieldForceTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectAll = () => {
    handleMultiSelectAll(
      labelTransactions,
      setLabelTransactions,
      selectedValue,
      selectableTransactions,
    );
  };
  const handleLabelTransactionSelect = (transaction) => {
    handleSingleSelect(labelTransactions, setLabelTransactions, selectedValue, {
      ...transaction,
      id: transaction?.txn_id,
    });
  };

  const handleTransactionClick = useCallback(
    (e, context) => {
      if (isLabelClicked) {
        handleLabelTransactionSelect(context);
        return;
      }

      if (context?.txn_id) {
        if (isEmbeddedPopup) {
          SetcurrentAccountId(context?.txn_id);
          setCloseCard(true);
        } else {
          const options =
            context?.lifecycle_status === "pending" &&
            services?.includes("AFieldForceTxn")
              ? {
                  state:
                    currentStatus === "require approval"
                      ? "require approval"
                      : context?.lifecycle_status,
                }
              : {};

          navigate(
            `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${context.txn_id}`,
            {
              replace: props?.HistoryPopup ? true : false,
              state: {
                isViewAll: location.pathname.includes("view_all"),
                options: options,
              },
            },
          );
          if (props.type === "field_force_txnViewAll_popup") {
            props.closeFieldForceTxnDetailsModal();
          }
        }
      }
    },
    [
      navigate,
      location.pathname,
      isLabelClicked,
      handleLabelTransactionSelect,
      props.type,
      currentStatus,
      closeCard,
      currentAccountId,
      isEmbeddedPopup,
      props.closeFieldForceTxnDetailsModal,
      services,
    ],
  );

  // CTA
  const isAccountScopedView =
    isFieldForceHistoryPopup ||
    ((isTxnHistoryPopup || props?.similarTxnType === "similarTxn") &&
      !!props?.bene_account_id);

  const clearParameterVisibility =
    searchdata ||
    !!currentStatus ||
    !!currentDistributionStatus ||
    !!isPaymentMethod ||
    !!currentCategory ||
    !!txnAmountFilter ||
    (!isAccountScopedView && !!selectedFfAccId) ||
    !!accountnumberstate ||
    (!isAccountScopedView && !!accountName) ||
    !!ownerAccId ||
    !!fFAccId ||
    !!currentIfscCode ||
    !!searchUserTextDebounce ||
    !!searchUserText ||
    !!(startDateFilter && endDateFilter) ||
    (Array.isArray(labelSearchText) &&
      labelSearchText.length > GlobalConfiguration?.lengthCheckZero);

  const handleClearParams = (e) => {
    setAnimateViewAll(false);
    e?.stopPropagation();
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSearchUserTextDebounce("");
    setSearchUserText("");
    setLabelSearchText([]);
    setaccountnumberstate("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentIfscCode("");

    if (isTxnHistoryPopup || isFieldForceHistoryPopup) {
      setIsPaymentMethod("");
      setOwnerAccId("");
      setTxnAmountFilter("");
      // setStartDateFilter("");
      // setEndDateFilter("");
      setCurrentDistributionStatus("");
      if (!isRejectAssociatedTxnPopup) {
        setCurrentStatus("");
      }
      if (!props?.categoryName) {
        setCurrentCategory("");
      }
      setSelectedFfAccId(props?.bene_account_id || props?.TxnHistoryid || "");
      setAccountName(
        props?.bene_account_name || props?.TxnHistoryAccountName || "",
      );
      SetsearchData("");
      return;
    }

    if (props?.similarTxnType !== "similarTxn") {
      setIsPaymentMethod("");
      setOwnerAccId("");
      setFfAccId("");
      setTxnAmountFilter("");
    }
    // setStartDateFilter("");
    // setEndDateFilter("");
    if (!isRejectAssociatedTxnPopup) {
      setCurrentStatus("");
    }
    setCurrentDistributionStatus("");
    if (!isEmbeddedPopup && !props?.categoryName) {
      setCurrentCategory("");
    }
    if (
      !isEmbeddedPopup &&
      !props?.TxnHistoryid &&
      !props?.bene_account_id &&
      props?.similarTxnType !== "similarTxn"
    ) {
      setSelectedFfAccId("");
    }
    SetsearchData("");
    if (!isEmbeddedPopup) {
      setAccountName("");
    }
    // Clear URL params in one go so back navigation doesn't restore filters
    if (!isEmbeddedPopup) {
      const keepPagesize = searchParam.get("pagesize") || dropdownOptions[0];
      navigate(
        {
          pathname: location.pathname,
          search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${keepPagesize}`,
        },
        { replace: true },
      );
    }
  };

  // Status

  const statuses = [
    "approved",
    "require approval",
    "pending",
    "rejected",
    "abandoned",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const hasAFieldForce = services?.includes("AFieldForceTxn");

    const hasCFieldForce = services?.includes("VFieldForceTxn");

    const fieldForceTxn =
      hasCFieldForce &&
      !hasAFieldForce &&
      !hasAdmin &&
      status === "require approval";

    const txnRequestTxn =
      hasAFieldForce && !hasCFieldForce && !hasAdmin && status === "pending";

    if (fieldForceTxn) {
      return false;
    }

    if (txnRequestTxn) {
      return false;
    }

    if (hasAdmin && hasAFieldForce && hasCFieldForce) {
      return true;
    }

    return true;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      default:
        return "var(--settled)";
    }
  };

  const handleDistributionChange = (selectedLabel) => {
    let statusToSend = "";
    switch (selectedLabel) {
      case "distribution created":
        statusToSend = "created";
        break;
      case "awaiting funds":
        statusToSend = "awaiting_funds";
        break;
      case "distribution initiated":
        statusToSend = "distribution_initiated";
        break;
      case "distribution rejected":
        statusToSend = "rejected";
        break;
      case "distribution complete":
        statusToSend = "distribution_complete";
        break;
      case "distribution abandoned":
        statusToSend = "abandoned";
        break;
      case "failed":
        statusToSend = "failed";
        break;
      default:
        break;
    }
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    handleSubmit("distribution", statusToSend);
    setCurrentDistributionStatus(statusToSend);
  };

  const getDisplayDistributionStatus = (status = "") => {
    switch (status) {
      case "created":
        return "distribution created";
      case "awaiting_funds":
        return "awaiting funds";
      case "distribution_initiated":
        return "distribution initiated";
      case "rejected":
        return "distribution rejected";
      case "distribution_complete":
        return "distribution complete";
      case "abandoned":
        return "distribution abandoned";
      case "failed":
        return "failed";
      default:
        return "";
    }
  };

  const getDistributionColor = (distribution_lifecycle_status) => {
    switch (distribution_lifecycle_status) {
      case "created":
        return "var(--queued)";
      case "awaiting_funds":
        return "var(--queued)";
      case "distribution_initiated":
        return "var(--queued)";
      case "distribution_complete":
        return "var(--settled)";
      case "abandoned":
        return "var(--abandoned)";
      case "failed":
        return "var(--queued)";
      default:
        return "var(--text-primary)";
    }
  };

  // USEEFFECT HOOKS

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  // Redirect

  useEffect(() => {
    if (location.state?.DistributionDashBoard && !navStateAppliedRef.current) {
      setCurrentStatus("all");
      setCurrentDistributionStatus(
        location.state.distribution_lifecycle_status || "all",
      );
      // setStartDateFilter(location.state.startDateLocationState || "");
      // setEndDateFilter(location.state.endDateLocationState || "");

      navStateAppliedRef.current = true;
      return;
    }
    handleAction();
  }, [
    dispatch,
    markerData,
    currentPage,
    searchUserText,
    isPaymentMethod,
    pageSize,
    ownerAccId,
    accountnumberstate,
    selectedFfAccId,
    currentStatus,
    currentDistributionStatus,
    startDateFilter,
    endDateFilter,
    currentIfscCode,
    currentCategory,
    txnAmountFilter,
    labelSearchText,
  ]);

  useEffect(() => {
    if (location.state?.DistributionDashBoard) {
      setCurrentStatus("all");
      setCurrentDistributionStatus(
        location.state?.distribution_lifecycle_status || "all",
      );
    }
  }, [
    location.state?.DistributionDashBoard,
    location.state?.distribution_lifecycle_status,
  ]);

  useEffect(() => {
    if (location.state?.approvalStatus && !navStateAppliedRef.current) {
      setCurrentStatus(location.state.approvalStatus);
      setCurrentDistributionStatus("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      navStateAppliedRef.current = true;
    }
  }, [location.state]);

  useEffect(() => {
    if (isEmbeddedPopup || lifecycleSyncedToUrlRef.current) {
      return;
    }
    const statusFromState = location?.state?.approvalStatus;
    if (statusFromState && statusFromState !== "all") {
      const valueToSync = statusFromState.toLowerCase?.() ?? statusFromState;
      handleSearchParams("lifecycle", valueToSync);
      lifecycleSyncedToUrlRef.current = true;
    }
  }, [location?.state?.approvalStatus, props.type, handleSearchParams]);

  useEffect(() => {
    if (location.state?.approvalStatus && !navStateAppliedRef.current) {
      setCurrentStatus(location.state.approvalStatus);
      setCurrentDistributionStatus("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);

      navStateAppliedRef.current = true;
    }
  }, [location.state]);

  useEffect(() => {
    let response;
    let data;
    setDataLoading(true);
    (async () => {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data = response?.payload?.categories?.map((itm) => {
            return {
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            };
          });
          setInputData(data);
          setDataLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          setDataLoading(false);
          break;

        case "Field force account":
          response = await dispatch(
            getAllFieldForceAccount({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 50,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.field_force_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          setInputData(data);
          setDataLoading(false);
          break;

        case "Search":
          setSearchUserText(searchUserTextDebounce);
          setDataLoading(false);
          break;

        case "Labels":
          data = labels
            ?.filter((itm) => {
              if (itm.includes(searchUserTextDebounce)) return true;
              else return false;
            })
            ?.map((val) => {
              return { id: val, Label: val, display: val };
            });
          setInputData(data);
          setDataLoading(false);
          break;
        default:
          break;
      }
      setDataLoading(false);
    })();
  }, [active]);

  return (
    <>
      <div
        className={`overflow-hidden bg-primary-bg ${isEmbeddedPopup && "h-full"} relative flex flex-col ${props?.typepop === "reimburse_txnViewAll_popup_reject" || props.typepop === "txnHistorypopup" || props.type === "field_force_txnViewAll_popup" ? "h-height-full" : "h-screen"} `}
      >
        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated transactions."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={labelTransactions}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={labelTransactions}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}
        {closeCard && (
          <div className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="emphasis"
              textSize="font-lg"
              subtext={"Leaving this page will exit from the current flow."}
              btnOneText="Stay"
              btnOneHandleFunction={() => setCloseCard(false)}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoHandleFunction={() => {
                setCloseCard(false);

                navigate(
                  `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${currentAccountId}`,
                  {
                    replace: props?.HistoryPopup ? true : false,
                    state: {
                      isViewAll: location.pathname.includes("view_all"),
                    },
                  },
                );
                SetcurrentAccountId("");
                if (props.type === "field_force_txnViewAll_popup") {
                  props.closeFieldForceTxnDetailsModal();
                }
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        <div
          className={`bg-primary-bg flex flex-col ${isEmbeddedPopup ? "h-full flex-1" : "h-height-full"}  `}
          id=" benetxnmain"
        >
          <div className={`transactionHistoryPop_topDiv hidden none `}></div>
          {/* Spacer for navbar / breadcrumb */}
          <div
            className={`${
              props?.similarTxnType === "similarTxn" ||
              props?.typepop === "reimburse_txnViewAll_popup_reject" ||
              props?.typepop === "txnHistorypopup"
                ? ""
                : `Qmd:min-h-navbar-breadcrumb-height ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}`
            } ${props?.type === "field_force_txnViewAll_popup" && "hidden"}`}
          ></div>
          <div
            className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${isEmbeddedPopup ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
          >
            <TopNavComponent
              direction={direction}
              topNavHeader={totalBalanceAmount}
              topNavSubText={"Total amount"}
              handleBack={() => {
                if (isLabelClicked) {
                  setisLabelClicked(false);
                } else if (isTxnHistoryPopup && props?.onClose) {
                  props.onClose();
                } else {
                  navigate(GlobalConfiguration?.navigate_back);
                }
              }}
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(labelTransactions) &&
                        labelTransactions.length >
                          GlobalConfiguration?.lengthCheckZero
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        if (
                          labelTransactions?.length >
                          GlobalConfiguration?.lengthCheckZero
                        ) {
                          setLabelTransactions([]);
                        } else {
                          setisLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                      hoverOption: "white",
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={isLabelClicked}
              isSelectionView={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign Labels",
                      btnType: "button",
                      enabledBgColor: labelTransactions?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (!labelTransactions.length) return;
                        setIsLabelPopupOpen(true);
                      },
                      enabledTextColor: labelTransactions?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                      isDisabled: !labelTransactions?.length,
                      inActiveVariantNeeded: true,
                    }
                  : undefined
              }
              BottomSubText={
                isLabelClicked
                  ? "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions."
                  : ""
              }
              BottomSubTextVaraint="primary"
              selectionText={`Transactions selected - ${labelTransactions?.length || GlobalConfiguration.lengthCheckZero}`}
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: `Select up to ${Number(selectedValue)}`,
                      enabledBgColor:
                        labelTransactions?.length === Number(selectedValue)
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)",

                      isDisabled:
                        loading ||
                        selectableTransactions?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (selectableTransactions?.length) {
                          handleSelectAll();
                        }
                      },

                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",

                      icon:
                        !loading &&
                        labelTransactions?.length === Number(selectedValue)
                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,

                      fullWidthRequired: false,

                      hoverOption: `${labelTransactions?.length === Number(selectedValue) ? "black" : "white"}`,
                    }
                  : undefined
              }
              isToggleNeeded={true}
              toggleProps={{
                state: toggleFFTxn,
                title: toggleFFTxn ? "Grid View" : "List View",
                isDisabled: false,
                handleClick: (e) => {
                  handleToggle(!toggleFFTxn);
                },
              }}
              ispagination={
                accumulatedData?.length <= GlobalConfiguration?.lengthCheckZero
                  ? false
                  : true
              }
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: loading,
                isFilterDisabled: loading,
                onSearchInput: (val) => setSearchUserTextDebounce(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search field force transaction",
                filterPlaceholder: "transaction details",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                      handleSubmit("search", val);
                      setSearchUserText(val);
                    },
                    isDropdown: false,
                    isDisabled: currentStatus === "require approval",
                  },
                  {
                    name: "Owner account",
                    short_name: "Own. Acc",
                    isMulti: false,
                    value: ownerAccId,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("sourceAcc", val);
                      setOwnerAccId(val);
                    },
                    setDisplayValue: setAccountNumber,
                    valueType: "string",
                    isDropdown: true,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.owner_account_id
                        ? true
                        : loading || currentStatus === "require approval",
                  },
                  {
                    name: "Field force account",
                    short_name: "Ff A/c",
                    isMulti: false,
                    value: selectedFfAccId,
                    displayValue:
                      accountName?.toLowerCase() ||
                      accountNameValue?.toLowerCase(),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("fFAcc", val);
                      setSelectedFfAccId(val);
                    },
                    setDisplayValue: (val) => {
                      setAccountName(val);
                      setAccountNameValue(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.field_force_account_id
                        ? true
                        : isTxnHistoryPopup && props?.bene_account_id
                          ? true
                          : props.type === "field_force_txnViewAll_popup"
                            ? true
                            : loading || currentStatus === "require approval",
                  },
                  {
                    name: "Amount",
                    short_name: "Amt - INR",
                    isMulti: false,
                    value: txnAmountFilter,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("amount", val);
                      setTxnAmountFilter(val);
                    },
                    displayValue: FormatAmount({ price: txnAmountFilter }),
                    isDropdown: false,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.amount
                        ? true
                        : loading || currentStatus === "require approval",
                    valueType: "number",
                  },
                  {
                    name: "Category",
                    short_name: "Cat",
                    valueType: "string",
                    isMulti: false,
                    value: currentCategory,
                    setValue: (val) => {
                      const c =
                        categories.filter((x) => x.id === val)[0]?.name ?? "";
                      setDisplayCategory(c);
                      handleSubmit("dispCat", c);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("category", val);
                      setCurrentCategory(val);
                    },
                    isDropdown: true,
                    isDisabled: props?.categoryName
                      ? true
                      : loading
                        ? true
                        : false,
                    displayValue: displayCategory,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelSearchText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit(
                        "label",
                        Array.isArray(val) ? val.join(",") : val,
                      );
                      setLabelSearchText(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading || currentStatus === "require approval",
                  },
                ],
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    value: currentStatus,
                    options: filteredStatuses.map((status) => status),
                    dropdownPlaceHolder:
                      currentStatus === "deleted"
                        ? "Discard"
                        : currentStatus === "rejected"
                          ? "Rejected"
                          : "Select status",
                    isDisabled: isRejectAssociatedTxnPopup
                      ? true
                      : currentDistributionStatus?.length >
                          GlobalConfiguration?.lengthCheckZero
                        ? true
                        : false,
                    statusPop: true,
                    handleChange: (val) => {
                      setAnimateViewAll(false);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("lifecycle", val);
                      setCurrentStatus(val);
                      if (val === "require approval") {
                        setIsPaymentMethod("");
                        setStartDateFilter("");
                        setEndDateFilter("");
                        handleSubmit("paymentmethod", "");
                        handleSubmit("date", "");
                      }
                    },
                  },
                  {
                    name: "Distribution status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayDistributionStatus(
                      currentDistributionStatus,
                    ),
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      currentStatus?.length >
                      GlobalConfiguration?.lengthCheckZero
                        ? true
                        : false,
                    options: [
                      "distribution created",
                      "awaiting funds",
                      "distribution initiated",
                      "distribution rejected",
                      "distribution complete",
                      "distribution abandoned",
                    ],
                    statusPop: true,
                    handleChange: handleDistributionChange,
                  },
                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value: startDateFilter && endDateFilter,
                    isDisabled:
                      currentStatus === "require approval" ? true : false,
                    startDate: startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration.intervalMedium,
                        )
                      : startDateFilter,
                    endDate: endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration.intervalMedium,
                        )
                      : endDateFilter,
                    handleChange: (date) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("date", date);
                      handleFilterDateRange(date);
                    },
                  },
                  {
                    name: "Payment method",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["NEFT", "RTGS"],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: "Select type",
                    value: isPaymentMethod,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.payment_method
                        ? true
                        : currentStatus === "require approval"
                          ? true
                          : false,
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("paymentmethod", val);
                      handlePaymentMethod(val);
                    },
                    dropdownType: "PaymentMethod",
                  },
                ],
                isFilterClearAllDisabled:
                  (props?.similarTxnType === "similarTxn" &&
                    props?.queryParams?.payment_method) ||
                  !(
                    (startDateFilter && endDateFilter) ||
                    isPaymentMethod?.length ||
                    (!isRejectAssociatedTxnPopup &&
                      currentStatus?.length >
                        GlobalConfiguration?.lengthCheckZero) ||
                    currentDistributionStatus?.length >
                      GlobalConfiguration?.lengthCheckZero
                  ),

                isSearchClearAllDisabled:
                  (isTxnHistoryPopup && props?.bene_account_id) ||
                  isFieldForceHistoryPopup
                    ? !(
                        currentCategory?.length ||
                        txnAmountFilter?.length ||
                        ownerAccId?.length ||
                        accountnumberstate?.length ||
                        labelSearchText?.length ||
                        (startDateFilter && endDateFilter) ||
                        searchUserText?.length
                      )
                    : (props?.similarTxnType === "similarTxn" &&
                        props?.queryParams?.amount) ||
                      !(
                        (!isEmbeddedPopup && currentCategory?.length) ||
                        (!isEmbeddedPopup && props?.categoryName?.length) ||
                        (!isEmbeddedPopup && props?.accountName?.length) ||
                        accountNameValue?.length ||
                        ownerAccId?.length ||
                        accountnumberstate?.length ||
                        (!isEmbeddedPopup && selectedFfAccId?.length) ||
                        txnAmountFilter?.length ||
                        labelSearchText?.length ||
                        (startDateFilter && endDateFilter) ||
                        searchUserText?.length
                      ),

                inputData: inputData,
                active: active,
                setActive: setActive,
                loading: dataLoading,
                setLoading: (e) => {},
                isShowFilter: true,
                isShowSortBy: false,
              }}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        isEmbeddedPopup ||
                        accumulatedData?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (
                          accumulatedData?.length ===
                          GlobalConfiguration.lengthCheckZero
                        ) {
                          return;
                        }
                        if (
                          isEmbeddedPopup ||
                          props?.typepop === "RejectAllTransactionPopup"
                        ) {
                          actionRestricted();
                        } else {
                          if (
                            services?.includes("ALabel") &&
                            services?.includes("RLabel")
                          ) {
                            setisLabelClicked((prev) => {
                              if (prev) setLabelTransactions([]);
                              return !prev;
                            });
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "ALabel,RLabel",
                              },
                            });
                          }
                        }
                      },
                      disabledBgColor:
                        isEmbeddedPopup ||
                        accumulatedData?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? ""
                          : "var(--text-primary)",
                      title:
                        "Labels will be used to generate statistics for the associated transactions.",
                    }
                  : undefined
              }
            />
          </div>

          {/* Transactions List / Grid */}
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          <div
            onScroll={handleScroll}
            ref={scrollContainerRef}
            id={isEmbeddedPopup ? "" : "infinityScrollContainerBeneView"}
            tabIndex="0"
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "mb-[var(--topnavbar-min-height)] Qsmd:mb-margin-base"
                  : ""
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none" : ""} ${
              props?.typepop === "RejectAllTransactionPopup" ||
              isEmbeddedPopup ||
              showInnerSearchBar
                ? `h-full flex flex-col flex-1 overflow-hidden ${isEmbeddedPopup && "overflow-y-auto"} min-h-0`
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0 overflow-y-auto "
            } flex-1 overflow-y-scroll z-z-index-base relative scroll-py-top_md`}
          >
            {loading ? (
              <div className="loader-container m-auto flex items-center justify-center h-full">
                <Loader />
              </div>
            ) : accumulatedData?.length ? (
              <div className={`flex-1 relative z-z-index-content`}>
                <div
                  className={`${
                    !toggleFFTxn
                      ? "standard-card-alignment"
                      : "standard-list-view-alignment"
                  } gap-x-gap-sm gap-y-gap-md`}
                >
                  {accumulatedData.map((transactions) => {
                    return !toggleFFTxn ? (
                      <CardContainer
                        filterRef={scrollContainerRef}
                        hoverHeight={
                          GlobalConfiguration?.reimbursementTxnCardHoverHeight
                        }
                        minHeight={GlobalConfiguration.BeneTxnCardMinHeight}
                        key={transactions?.txn_id}
                        isNoCursorRequired={
                          isRejectAssociatedTxnPopup ? true : false
                        }
                        onClickHandler={(e) => {
                          if (
                            showInnerSearchBar ||
                            isRejectAssociatedTxnPopup
                          ) {
                            return;
                          } else {
                            if (
                              isActionRestrictedMode ||
                              props.alert === "alertpopup" ||
                              props?.similarTxnType === "similarTxn"
                            ) {
                              actionRestricted();
                            } else {
                              handleTransactionClick(e, transactions);
                            }
                          }
                          // if (isLabelClicked) {
                          //   handleTransactionClick(e, transactions);
                          // } else {
                          //   toast.info("Feature coming soon", toast_position);
                          // }
                        }}
                        isSelected={
                          Array.isArray(labelTransactions) &&
                          labelTransactions?.some(
                            (item) => item?.id === transactions?.txn_id,
                          )
                        }
                      >
                        <card-body>
                          {transactions?.amount ? (
                            <TextWithIcon
                              type="Amount"
                              isAbbrevation={true}
                              fontWeight="semibold"
                              text={transactions?.amount}
                              subText="Amount"
                              textColor="var(--settled)"
                              iconComponentArray={[
                                ...(transactions?.confidential_transaction ===
                                "Y"
                                  ? [
                                      {
                                        icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                        title: "confidential",
                                        isDisabled: false,
                                      },
                                    ]
                                  : []),

                                // Label icon
                                ...(isLabelClicked &&
                                transactions?.distribution_lifecycle_status !==
                                  "distribution_complete"
                                  ? [
                                      {
                                        icon: labelTransactions?.some(
                                          (item) =>
                                            item?.id === transactions?.txn_id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE,
                                        isDisabled: false,
                                      },
                                    ]
                                  : []),
                              ]}
                            />
                          ) : (
                            <TextWithIcon
                              type="Text"
                              fontWeight="semibold"
                              text="N/A"
                              subText="Amount"
                              textColor="var(--settled)"
                              iconComponentArray={
                                isLabelClicked &&
                                transactions?.distribution_lifecycle_status !==
                                  "distribution_complete"
                                  ? [
                                      {
                                        icon: labelTransactions?.some(
                                          (item) =>
                                            item?.id === transactions?.txn_id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE,
                                        isDisabled: false,
                                      },
                                    ]
                                  : []
                              }
                            />
                          )}

                          <TextWithIcon
                            text={
                              transactions?.field_force_account_name
                                ? transactions?.field_force_account_name
                                : "N/A"
                            }
                            type="Text"
                            subText="Account name"
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                          />

                          <TextWithBank
                            text={
                              transactions?.created_on
                                ? formatDateViewAll(
                                    transactions?.created_on,
                                    false,
                                    false,
                                  )
                                : "Not given"
                            }
                            subText="Created on"
                            type="Text"
                            src={
                              categoryMapper(
                                transactions?.category_id?.category_id,
                              )?.url
                            }
                            imgColor={
                              categoryMapper(
                                transactions?.category_id?.category_id,
                              )?.colour
                            }
                            ifscCode={
                              transactions?.field_force_account_ifsc_code
                            }
                          />
                        </card-body>

                        <card-hover>
                          <TextWithIcon
                            text={
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subText="Approval status"
                            textCase="capitalize"
                            fontWeight="semibold"
                            textColor={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                          />

                          <TextWithIcon
                            text={
                              transactions?.distribution_lifecycle_status ===
                              "created"
                                ? "Distribution created"
                                : transactions?.distribution_lifecycle_status ===
                                    "awaiting_funds"
                                  ? "Awaiting funds"
                                  : transactions?.distribution_lifecycle_status ===
                                      "distribution_initiated"
                                    ? "Distribution initiated"
                                    : transactions?.distribution_lifecycle_status ===
                                        "abandoned"
                                      ? "Distribution abandoned"
                                      : transactions?.distribution_lifecycle_status ===
                                          "rejected"
                                        ? "Distribution rejected"
                                        : transactions?.distribution_lifecycle_status ===
                                            "failed"
                                          ? "Failed"
                                          : transactions?.distribution_lifecycle_status ===
                                              "distribution_complete"
                                            ? "Distribution complete"
                                            : "N/A"
                            }
                            subText="Distribution status"
                            fontWeight="semibold"
                            textColor={
                              transactions?.distribution_lifecycle_status ===
                              "N/A"
                                ? "var(--text-primary)"
                                : getDistributionColor(
                                    transactions?.distribution_lifecycle_status,
                                  )
                            }
                          />

                          <TextWithIcon
                            text={
                              transactions?.labels?.length
                                ? transactions.labels.join(", ")
                                : "Not assigned"
                            }
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                          />
                        </card-hover>
                      </CardContainer>
                    ) : (
                      <ListContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementTxnListHoverHeight
                        }
                        key={transactions?.txn_id}
                        filterRef={scrollContainerRef}
                        onClickHandler={(e) => {
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (
                              isActionRestrictedMode ||
                              props.alert === "alertpopup" ||
                              props?.similarTxnType === "similarTxn"
                            ) {
                              actionRestricted();
                            } else {
                              handleTransactionClick(e, transactions);
                            }
                          }
                          // if (isLabelClicked) {
                          //   handleTransactionClick(e, transactions);
                          // } else {
                          //   toast.info("Feature coming soon", toast_position);
                          // }
                        }}
                        isSelected={
                          Array.isArray(labelTransactions) &&
                          labelTransactions?.some(
                            (item) => item?.id === transactions?.txn_id,
                          )
                        }
                      >
                        <list-body>
                          <div className="w-full flex justify-between pr-padding-sm py-padding-sm gap-x-gap-sm">
                            <div
                              className={`flex flex-col gap-y-gap-sm w-full`}
                            >
                              <div className="w-full flex gap-x-gap-sm">
                                <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-tr-border-radius-md rounded-br-border-radius-md">
                                  <div className="flex gap-x-gap-sm items-center">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={
                                        transactions?.field_force_account_ifsc_code
                                      }
                                    />
                                    <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                                    <SVGComponent
                                      url={
                                        categoryMapper(
                                          transactions?.category_id
                                            ?.category_id,
                                        )?.url
                                      }
                                      color={
                                        categoryMapper(
                                          transactions?.category_id
                                            ?.category_id,
                                        )?.colour
                                      }
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                    />
                                  </div>
                                </div>
                                <p className="overflow-hidden whitespace-nowrap overflow-ellipsis items-center text-settled text-font-xs flex-1 flex font-semibold ">
                                  <span>
                                    {"INR " +
                                      Number(
                                        transactions?.amount,
                                      )?.toLocaleString("en-IN", {
                                        minimumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                        maximumFractionDigits:
                                          GlobalConfiguration?.lengthCheckTwo,
                                      })}
                                  </span>
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p className="text-text-primary font-normal text-font-xs min-w-standard-account-min-width  text-right">
                                    {transactions.created_on
                                      ? formatDateViewAll(
                                          transactions?.created_on,
                                          false,
                                          false,
                                        )
                                      : "Not given"}
                                  </p>

                                  {isLabelClicked &&
                                  transactions?.distribution_lifecycle_status !==
                                    "distribution_complete" ? (
                                    <SVGComponent
                                      url={
                                        labelTransactions?.some(
                                          (item) =>
                                            item?.id === transactions?.txn_id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE
                                      }
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              <div className="w-full pl-padding-sm flex justify-between items-center">
                                <p
                                  className={`text-font-xs flex-1 text-text-primary truncate font-normal`}
                                >
                                  <TickerAnimation
                                    text={
                                      transactions?.field_force_account_name
                                        ? transactions.field_force_account_name
                                        : "N/A"
                                    }
                                  />
                                </p>
                                <div
                                  style={{
                                    display:
                                      transactions?.confidential_transaction ===
                                      "Y"
                                        ? "flex"
                                        : "none",
                                  }}
                                  className="gap-x-gap-sm ml-margin-sm justify-end"
                                >
                                  <SVGComponent
                                    url={ICONS?.CONFIDENTIAL_TRANSACTION}
                                    height={"var(--icon-sm)"}
                                    width={"var(--icon-sm)"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </list-body>

                        <list-hover>
                          <ListDualText
                            text1={
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subtext1="Approval status"
                            textCase1="capitalize"
                            text1FontWeight="semibold"
                            text1Color={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                            text2={
                              transactions?.distribution_lifecycle_status ===
                              "created"
                                ? "Distribution created"
                                : transactions?.distribution_lifecycle_status ===
                                    "awaiting_funds"
                                  ? "Awaiting funds"
                                  : transactions?.distribution_lifecycle_status ===
                                      "distribution_initiated"
                                    ? "Distribution initiated"
                                    : transactions?.distribution_lifecycle_status ===
                                        "abandoned"
                                      ? "Distribution abandoned"
                                      : transactions?.distribution_lifecycle_status ===
                                          "rejected"
                                        ? "Distribution rejected"
                                        : transactions?.distribution_lifecycle_status ===
                                            "failed"
                                          ? "Failed"
                                          : transactions?.distribution_lifecycle_status ===
                                              "distribution_complete"
                                            ? "Distribution complete"
                                            : "N/A"
                            }
                            subtext2="Distribution status"
                            textCase="none"
                            text2FontWeight="semibold"
                            text2Color={
                              transactions?.distribution_lifecycle_status ===
                              "N/A"
                                ? "var(--text-primary)"
                                : getDistributionColor(
                                    transactions?.distribution_lifecycle_status,
                                  )
                            }
                          />

                          <ListTextWithIcon
                            type="text"
                            text={
                              transactions?.labels?.length
                                ? transactions.labels.join(", ")
                                : "Not assigned"
                            }
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                          />
                        </list-hover>
                      </ListContainer>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div
                className={`flex flex-col items-center justify-center m-auto mt-auto h-full ${
                  showInnerSearchBar
                    ? "overflow-y-hidden pointer-events-none"
                    : ""
                }`}
              >
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    No data found.
                  </p>
                  {clearParameterVisibility ? (
                    <div>
                      <PrimaryButton
                        enabledBgColor="var(--primary-nav-act)"
                        btnText="Clear parameters"
                        btnType="button"
                        handleFunction={handleClearParams}
                        enabledTextColor="var(--text-primary)"
                      />
                    </div>
                  ) : null}
                </div>

                {isLabelClicked ? (
                  <div
                    className={`h-navbar-breadcrumb-height mb-margin-xl block Qmd:hidden ${
                      (props?.typepop === "RejectAllTransactionPopup" ||
                        isTxnHistoryPopup) &&
                      "mb-margin-bottom-pop-up"
                    }`}
                  ></div>
                ) : null}
              </div>
            )}
            {/* Transactions List / Grid */}
          </div>
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
            <div
              className={`${loading && "hidden"} rounded-none bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} w-full h-pagination-height ${showInnerSearchBar && `pointer-events-none  `} ${
                props?.typepop === "RejectAllTransactionPopup"
                  ? "h-auto Qmd:h-status_all_height"
                  : "h-pagination-height"
              }`}
            >
              <div
                className={`${
                  showInnerSearchBar &&
                  "opacity-dark-opacity  pointer-events-none h-full"
                }`}
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={(e) => {}}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FieldForceTransactionViewAll;
